import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from '@/utils';
import empty from '../empty.vue';
export default {
  name: 'birthday',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    defaultValue: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    parentKey: String
  },
  components: {
    empty: empty
  },
  data: function data() {
    return {
      isEmpty: isEmpty,
      activeTab: ''
    };
  },
  computed: {
    goodsList: function goodsList() {
      var default_value = this.value.default_value || [];
      if (this.parentKey) {
        default_value = this.defaultValue;
      }
      if (this.value.config.is_open_ad === '1') {
        default_value = default_value.slice(0, default_value.length - 1);
      }
      return default_value;
    },
    tabList: function tabList() {
      var _list$;
      var list = this.value.config.value.filter(function (i) {
        return Boolean(i.flag);
      });
      this.activeTab = (_list$ = list[0]) === null || _list$ === void 0 ? void 0 : _list$.id;
      return list;
    }
  }
};